export default [
  {
    path: '/pre-invoices',
    name: 'pre-invoice',
    meta: { requiresAuth: true },
    component: () => import('./views/index.vue')
  },
  {
    path: '/pre-invoices/create',
    name: 'pre-invoice-create',
    meta: { requiresAuth: true },
    component: () => import('./views/create.vue')
  },
  {
    path: '/pre-invoices/:id',
    name: 'pre-invoice-show',
    meta: { requiresAuth: true },
    component: () => import('./views/show.vue')
  },
  {
    path: '/pre-invoices/:id/edit',
    name: 'pre-invoice-edit',
    meta: { requiresAuth: true },
    component: () => import('./views/edit.vue')
  },
  {
    path: '/pre-invoices/:id/approve',
    name: 'pre-invoice-approve',
    meta: { requiresAuth: true },
    component: () => import('./views/approve.vue')
  }
]
